import React from "react"
import { GetApp } from "../App"
import { classNames } from "../Components"
import { Overlay, OverlayTitle } from "../Components/Overlay"

export interface OverlayViewDefinition {
  close?: boolean;
  title?: string;
  style?: "default" | "warning" | "danger" | "alarm";
  className?: string;
  render: () => React.ReactNode | undefined;
}

export interface OverlayViewDefinitions {
  [name: string]: OverlayViewDefinition;
}

interface OverlayViewProps {
  className?: string;
  overlay?: string;
  overlays: OverlayViewDefinitions;
  resetOverlay?: () => void;
}

export const OverlayViewData = {
  // Resolve the active overlay definition by name. Throws when a name is given
  // that has no matching definition, and returns undefined when no overlay is
  // selected (empty name).
  resolveOverlay(overlays: OverlayViewDefinitions, overlay?: string): OverlayViewDefinition | undefined {
    if (overlay && !overlays[overlay]) {
      throw new Error(`OverlayView: Unknown overlay "${overlay}"`);
    }
    return overlay ? overlays[overlay] : undefined;
  },
};

export function OverlayView({ className, overlay, overlays, resetOverlay }: OverlayViewProps) {
  const _app = GetApp();

  const o = OverlayViewData.resolveOverlay(overlays, overlay);
  if (!o) {
    return null;
  }
  const content = o.render();
  if (!content) {
    return null;
  }

  return (
    <Overlay key={overlay} className={classNames([className, o.className])} closeCallback={resetOverlay} closeBackground={o.close} style={o.style || "default"} hideClose={!o.close}>
      {o.title && <OverlayTitle title={o.title} style={o.style || "default"} closeCallback={resetOverlay} hideClose={!o.close} />}
      {content}
    </Overlay>
  );
}
